<div class="toast-container position-absolute top-0 end-0 p-3 toast-margin">
  @for (toast of toasts; track toast.id) {
    <div class="toast d-block" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        @if (toast.loading) {
          <mat-spinner class="small-spinner"></mat-spinner>
        }
        <strong class="me-auto ms-3">{{ toast.title }}</strong>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeToast(toast.id)"></button>
      </div>
      @if (!!toast.body) {
        <div class="toast-body">
          {{ toast.body }}
        </div>
      }
    </div>
  }
</div>